module.exports = __webpack_public_path__ + "static/media/eternalbluesuccess.4cee99fa.jpg";